import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register, formatErr } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success("Account created");
      nav("/classes");
    } catch (err) { toast.error(formatErr(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="register-page">
      <span className="label-overline">// Join</span>
      <h1 className="font-display text-5xl tracking-widest leading-none mt-3 mb-10">Create account</h1>

      <form onSubmit={onSubmit} className="space-y-5" data-testid="register-form">
        <div>
          <label className="label-overline block mb-2">Name</label>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full bg-[#2A2018] border border-white/15 px-4 py-3 focus:border-[#D4A574] outline-none" data-testid="register-name-input" />
        </div>
        <div>
          <label className="label-overline block mb-2">Email</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full bg-[#2A2018] border border-white/15 px-4 py-3 focus:border-[#D4A574] outline-none" data-testid="register-email-input" />
        </div>
        <div>
          <label className="label-overline block mb-2">Password</label>
          <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="w-full bg-[#2A2018] border border-white/15 px-4 py-3 focus:border-[#D4A574] outline-none" data-testid="register-password-input" />
        </div>
        <button disabled={loading} className="kinetic-btn w-full" data-testid="register-submit-btn">
          {loading ? "Creating…" : "Create Account"}
        </button>
      </form>
      <p className="mt-8 text-sm text-zinc-400">Already have an account? <Link to="/login" className="text-[#D4A574]" data-testid="go-login-link">Sign in</Link></p>
    </div>
  );
}
